export const redirectToErrorPageMessage = "User redirected to error page";
export const redirectToTimedoutPageMessage = "User redirected to timeout page";
